<template>
  <div class="p-4">
    <h2 class="py-5">Logowanie</h2>
    <form class="container bg-light py-5" @submit.prevent="login">
      <div class="mb-3">
        <label for="exampleInputEmail1" class="form-label">E-mail</label>
        <input v-model="email" type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp">
      </div>
      <div class="mb-3">
        <label for="exampleInputPassword1" class="form-label">Hasło</label>
        <input v-model="password" type="password" class="form-control" id="exampleInputPassword1">
      </div>
      <button type="submit" class="btn btn-primary">Zaloguj</button>
    </form>
  </div>
</template>

<script>
import axios from 'axios'
import { $axios } from '@/modules/http/axios'
import Swal from 'sweetalert2'

export default {
  name: 'Login',
  data () {
    return {
      email: '',
      password: ''
    }
  },
  methods: {
    login () {
      axios.post(`${process.env.VUE_APP_API_BASE_URL}Account/Login`, {
        email: this.email,
        password: this.password
      }, {
        auth: {
          username: this.email,
          password: this.password
        }
      }).then(response => {
        localStorage.setItem('accessToken', response.data.token)
        localStorage.setItem('username', response.data.user.name)
        localStorage.setItem('email', response.data.user.email)
        localStorage.setItem('permissions', response.data.user.permission)
        $axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('accessToken')}`
        Swal.fire('Zalogowano', '', 'success')
        this.$router.push('/')
      }).catch(error => {
        console.log(error)
        Swal.fire('Coś poszło nie tak', '', 'error')
      })
    }
  }
}
</script>
